export default __webpack_public_path__ + "static/04-a4fa893b30df2449175a13d324c0f1ed.gif";